import { create } from 'zustand';

import { ProjectTaskType } from '../lib/types';

type ProjectLoadingTaskState = {
  actionBeforePolling: (() => Promise<void>) | null;
  isInitialized: boolean;
  projectLoadingTask: null | ProjectTaskType;
};

type ProjectLoadingTaskStateActions = {
  resetProjectLoadingState: () => void;
  updateProjectLoadingState: (newState: {
    actionBeforePolling?: ProjectLoadingTaskState['actionBeforePolling'];
    projectLoadingTask: ProjectLoadingTaskState['projectLoadingTask'];
  }) => void;
};

const initialState: ProjectLoadingTaskState = {
  actionBeforePolling: null,
  isInitialized: false,
  projectLoadingTask: null,
};

export const useProjectLoadingTaskStore = create<ProjectLoadingTaskState & ProjectLoadingTaskStateActions>((set) => ({
  ...initialState,
  resetProjectLoadingState: () => set(initialState),
  updateProjectLoadingState: ({ actionBeforePolling, projectLoadingTask }) =>
    set(() => ({ actionBeforePolling: actionBeforePolling || null, isInitialized: true, projectLoadingTask })),
}));
